import {
  createContext,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";
import { useRouter } from "next/router";
import { withActiveToken } from "../lib/auth";
import { getAPIURL } from "../lib/utils";
import BusinessContext from "./business-context";

const SideBarContext = createContext({
  isSideBarOpen: false,
  setIsSideBarOpen: () => {},
  toggleSideBar: () => {},
  isChatHistory: false,
  setIsChatHistory: () => {},
  toggleChatHistory: () => {},
  isCanvasOpen: false,
  setIsCanvasOpen: () => {},
  toggleCanvas: () => {},
  chats: [],
  setChats: () => {},
  fetchChats: () => {},
  isMyAppsOpen: false,
  setIsMyAppsOpen: () => {},
  toggleMyApps: () => {},
  isSettingsOpen: false,
  setIsSettingsOpen: () => {},
  toggleSettings: () => {},
});

export const SideBarProvider = (props) => {
  const [isSideBarOpen, setIsSideBarOpen] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth >= 1024; 
    }
    return false;
  });
  const [isChatHistory, setIsChatHistory] = useState(false);
  const [chats, setChats] = useState([]);
  const [isCanvasOpen, setIsCanvasOpen] = useState(false);
  const [isMyAppsOpen, setIsMyAppsOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const router = useRouter();
  const { activeBusiness } = useContext(BusinessContext);
  

  // Toggle sidebar
  const toggleSideBar = () => {
    setIsSideBarOpen((prev) => !prev);
  };

  // Toggle chat history
  const toggleChatHistory = () => {
    setIsChatHistory((prev) => !prev);
  };

  //toggle settings
  const toggleSettings = () => {
    setIsSettingsOpen((prev) => !prev);
  }

  // toggle canvas
  const toggleCanvas = () => {
    if (router.asPath === "/chats/new"){
      setIsCanvasOpen(false);
    }else{
    setIsCanvasOpen((prev) => !prev);
    setIsSideBarOpen(false);
    setIsChatHistory(false);
    }
  };
  //tggle my apps
  const toggleMyApps = () => {
    setIsMyAppsOpen(!isMyAppsOpen);
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      const isMacOS = 
        navigator.platform.toUpperCase().includes('MAC') || 
        (navigator.userAgent && navigator.userAgent.toUpperCase().includes('MAC'));
  
      const isModKey = isMacOS ? event.metaKey : event.ctrlKey;
  
      if (isModKey && event.key === '\\') {
        event.preventDefault();
        toggleSideBar();
      }
  
      if (isModKey && (event.key === 'h' || event.key === 'H')) {
        event.preventDefault();
        toggleChatHistory();
      }

      if (isModKey && event.shiftKey && (event.key === 'p' || event.key === 'P')) {
        event.preventDefault();
        toggleMyApps();
      }
    };
  
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggleSideBar, toggleChatHistory]);
  
  const fetchChats = useCallback(() => {
    if (!activeBusiness?.uuid) return; 
    return withActiveToken(() => {
      fetch(getAPIURL(`businesses/${activeBusiness?.uuid}/chats/`), {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json().then((json) => {
              setChats(json);
            });
          } else {
            return res.json().then((json) => Promise.reject(json));
          }
        })
        .catch((error) => {
          console.error("Failed to fetch chats:", error);
        });
    }, router);
  }, [activeBusiness, router]);


  useEffect(() => {
      fetchChats();
  }, [activeBusiness, fetchChats]);


  const context = {

    isSideBarOpen,
    setIsSideBarOpen,
    toggleSideBar,

    isChatHistory,
    setIsChatHistory,
    toggleChatHistory,

    chats,
    setChats,
    fetchChats,

    isCanvasOpen,
    setIsCanvasOpen,
    toggleCanvas,

    isMyAppsOpen,
    setIsMyAppsOpen,
    toggleMyApps,

    isSettingsOpen,
    setIsSettingsOpen,
    toggleSettings,
  };

  return (
    <SideBarContext.Provider value={context}>
      {props.children}
    </SideBarContext.Provider>
  );
};

export default SideBarContext;
